import SidebarLoader from "./SidebarLoader";

// Component to render a single message bubble
export default function RenderMessage({
  msg,
  index,
  msgIndex,
  isTtgUser,
  Markdown,
  MarkdownContainer,
  MessageBubble,
  formatJsonConfigIfExist,
  MessageGroup,
}) {
  const msgs = msg.split(/(?=CONFIG_START)/);

  return msgs.map((item, i) => {
    const start = item.includes("CONFIG_START");
    const end = !item.includes("CONFIG_END");

    // Show loader if config is not finished
    if (!isTtgUser && start && end) {
      return (
        <MessageGroup
          key={`loader-${index}-${msgIndex}-${i}`}
          MessageGroup={MessageGroup}
        >
          <SidebarLoader />
        </MessageGroup>
      );
    }

    const text = formatJsonConfigIfExist(item);

    if (!text) return null;

    return (
      <MessageGroup isUser={false} key={`msg-${index}-${msgIndex}-${i}`}>
        <MessageBubble isUser={false}>
          <MarkdownContainer>
            <Markdown>{text}</Markdown>
          </MarkdownContainer>
        </MessageBubble>
      </MessageGroup>
    );
  });
}
